import $ from 'jquery';
import _ from 'underscore';
import { sortableHeaderTemplate, validateOrder } from '@bingads-webui-campaign/summary-grid-helper';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';


export function getConfig({
  repository,
  gridName,
  preferenceConfig,
  filterService,
  columnConfig,
  viewport,
  customHeaderOffset,
  i18n,
  permissions,
}) {
  const headRows = ['column-header-rows'];

  const tableName = i18n.getString('TargetingSettings_Locations');
  const gridConfig = {
    name: gridName,
    logacyGridName: 'LocationsGrid',
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    dataSource: repository.getDataSource(),
    query: repository.getQuery(),
    rows: {
      headRows,
    },
    columns: columnConfig.getColumnsConfig(),
    scrolling: {
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
        attributes: { 'aria-label': i18n.getString('{{tableName}} table header', { tableName }) },
      },
      virtualized: true,
    },
    i18n: TargetingSettingsContext.i18n,
    ...({
      selection: true,
      filterService,
      sortableHeader: {
        template: sortableHeaderTemplate,
      },
    }),
    preferenceService: TargetingSettingsContext.preferencesService,
    config: TargetingSettingsContext.config,
  };

  validateOrder(preferenceConfig, gridConfig.columns, 'settings_locations', permissions);
  gridConfig.dataSource = _.omit(gridConfig.dataSource, 'query');

  if (viewport) {
    gridConfig.scrolling.viewport = viewport;
  }

  return gridConfig;
}
